import { Modal } from '@ag1/ui';
import { useSiteCart } from '@portal/shared/components/SiteCart/hooks/SiteCartContext';
import { cartEvents } from 'analytics/events';
import { SiteCartContent } from './components/SiteCartContent/SiteCartContent';
import { SiteCartEmptyState } from './components/SiteCartEmptyState/SiteCartEmptyState';
import { SiteCartFooter } from './components/SiteCartFooter/SiteCartFooter';
import { SiteCartHeader } from './components/SiteCartHeader/SiteCartHeader';
import styles from './SiteCart.module.scss';

const SiteCart = () => {
  const { cartId, isOpen, closeCart } = useSiteCart();

  if (!isOpen) return null;

  return (
    <Modal
      className={styles.modalContainer}
      isOpen={isOpen}
      onClose={() => {
        cartEvents.closeCart();
        closeCart();
      }}
      id="SiteCart">
      <SiteCartHeader />

      <Modal.Content className={styles.modalContent}>
        {cartId ? <SiteCartContent /> : <SiteCartEmptyState />}
      </Modal.Content>

      {cartId && <SiteCartFooter />}
    </Modal>
  );
};

export default SiteCart;
